<nz-badge [nzCount]="alertCounts" [nzOffset]="15">
  <i class="fas fa-bell"></i>
</nz-badge>
